import React, { useState } from "react";
import { changeAdminPassword, changeStaffPassword } from "../api/authApi";
import "./css/ChangePasswordPage.css";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

// ─── Change Password (logged-in admin) ─────────────────────────────────────
// POST /api/auth/admin/change-password   { currentPassword, newPassword }
// Backend: authController.js → changeAdminPassword (uses req.user.id from JWT)

const ChangePasswordPage = () => {
  // const dispatch = useDispatch();
  // const token = useSelector((state) => state.auth.token);
  const reduxAdmin = useSelector((state) => state.auth.admin);

    const role = reduxAdmin?.role;
  const isSuperAdmin = role === "SUPERADMIN";

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const resetForm = () => {
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!currentPassword || !newPassword || !confirmPassword) {
      setError("Please fill in all fields.");
      return;
    }
    if (newPassword.length < 6) {
      setError("New password must be at least 6 characters.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("New password and confirm password do not match.");
      return;
    }
    if (newPassword === currentPassword) {
      setError("New password must be different from current password.");
      return;
    }

    setLoading(true);
    try {
      
      const data = isSuperAdmin ? await changeAdminPassword({ currentPassword, newPassword }) : await changeStaffPassword({ currentPassword, newPassword });   

      if (data.success) {
        setSuccess("Password updated successfully.");
         toast.success("Password updated successfully!");
        resetForm();
      } else {
        setError(data.message || "Failed to update password.");
        toast.error(data.message || "Failed to update password.");
      }
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Server error. Please try later.",
      );
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          "Server error. Please try later.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cp-wrapper">
      <div className="cp-card">
        <h2 className="cp-title">Change Password</h2>
        <p className="cp-subtitle">
          Update the password used to log in to your admin account.
        </p>

        <form onSubmit={handleSubmit} autoComplete="off">
          <label className="cp-label">Current Password</label>
          <div className="cp-password-field">
            <input
              type={showCurrent ? "text" : "password"}
              placeholder="Enter current password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              className="cp-input"
              autoComplete="off"
            />
            <span className="cp-eye-icon" onClick={() => setShowCurrent(!showCurrent)}>
              {showCurrent ? "🙈" : "👁️"}
            </span>
          </div>

          <label className="cp-label">New Password</label>
          <div className="cp-password-field">
            <input
              type={showNew ? "text" : "password"}
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="cp-input"
              autoComplete="off"
            />
            <span className="cp-eye-icon" onClick={() => setShowNew(!showNew)}>
              {showNew ? "🙈" : "👁️"}
            </span>
          </div>

          <label className="cp-label">Confirm New Password</label>
          <div className="cp-password-field">
            <input
              type={showConfirm ? "text" : "password"}
              placeholder="Re-enter new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="cp-input"
              autoComplete="off"
            />
            <span className="cp-eye-icon" onClick={() => setShowConfirm(!showConfirm)}>
              {showConfirm ? "🙈" : "👁️"}
            </span>
          </div>

          {error && <p className="cp-error-text">{error}</p>}
          {success && <p className="cp-success-text">{success}</p>}

          <button type="submit" disabled={loading} className="cp-btn">
            {loading ? "Updating..." : "Update Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordPage;